import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Grid, Typography } from '@mui/material';
import { withRouter } from 'react-router';
import { goToAnalysis } from '../../../../components/ClientEntry/utils';
import BarChart3 from 'lucide-react/dist/esm/icons/bar-chart-3';

const ButtonStyle = {
  padding: 3,
  lineHeight: 1,
  minWidth: 71,
  textTransform: 'unset'
};

const IconWrapperStyle = {
  margin: '4px 0'
};

const AnalysisButton = props => {
  const { intl, client, history, style } = props;

  const onClick = () => {
    if (!client) {
      localStorage.removeItem('clientId');
      history.push({
        pathname: '/need-analysis',
        state: {
          previousPath: history.location.pathname,
          clientFactsheetDetail: { clientIncData: { currentSlide: 3 } }
        }
      });
    } else {
      goToAnalysis(client, history, 'Saving');
    }
  };

  return (
    <Button color="primary" onClick={onClick} style={{ ...ButtonStyle, ...style }}>
      <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <Grid style={IconWrapperStyle}>
          <BarChart3 size={24} color="var(--new-theme)" />
        </Grid>
        <Grid>
          <Typography align="center" color="textSecondary">
            {intl.formatMessage({ id: 'Analysis' })}
          </Typography>
        </Grid>
      </Grid>
    </Button>
  );
};

export default injectIntl(withRouter(AnalysisButton));
